// Vuex authServicesPoints module main file
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  tokenIsValid: false,
  isWaitingForAuthServicePointData: true,
  params: [],
  type: null,
  platform_url: null,
  gateway: null,
  afterAuthorizationUrl: null,
};

const getters = {
  tokenIsValid: state => state.tokenIsValid,
  isWaitingForAuthServicePointData: state => state.isWaitingForAuthServicePointData,
  form: state => ({
    params: state.params,
    type: state.type,
  }),
  gateway: state => state.gateway,
  platformUrl: state => state.platform_url,
  afterAuthorizationUrl: state => state.afterAuthorizationUrl,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;



// WEBPACK FOOTER //
// ./src/store/modules/authServicesPoints/index.js